import React, { PureComponent } from 'react'
import { object } from 'prop-types'
import { Table } from 'reactstrap'
import { TableHeader, TableCell, MinutesTableCell, SpeedTableCell } from 'components'
import { translate } from 'react-i18next'
import { sortBy, range } from 'lodash'
import './Race.css'

@translate()
export class RaceTabCumulative extends PureComponent {
    static propTypes = {
        data: object.isRequired
    }

    renderSpeedHeader = num => (
        <TableHeader key={num} tag="th" className="Speed">
            <div className="no-wrap" dangerouslySetInnerHTML={{ __html: this.props.t('game.RACE.tableHeaders.race', { num }) }} />
        </TableHeader>
    )
    renderRowPlayer = ({ id, position, player, points, time, speeds }) => (
        <tr key={id}>
            <TableCell tag="td" className="Big text-center">{position}</TableCell>
            <TableCell tag="td" className="text-center">{player}</TableCell>
            <TableCell tag="td" className="text-center">{points}</TableCell>
            <MinutesTableCell tag="td" className="text-center">{time}</MinutesTableCell>
            {speeds.map(this.renderSpeed)}
        </tr>
    )
    renderSpeed = (data, index) => <SpeedTableCell key={index} tag="td" {...data} />

    render() {
        const { data = {}, t } = this.props
        const players = data.players.map(p => ({ id: p.id, player: p.player, ...p.cumulative }))
        return (
            <div className="RaceTabCumulative h-100">
                <Table className="vertical-center">
                    <thead>
                        <tr>
                            <TableHeader tag="th" className="text-center">{t('game.RACE.tableHeaders.position')}</TableHeader>
                            <TableHeader tag="th" className="text-center">{t('game.RACE.tableHeaders.player')}</TableHeader>
                            <TableHeader tag="th" className="text-center">{t('game.RACE.tableHeaders.points')}</TableHeader>
                            <TableHeader tag="th" className="text-center">{t('game.RACE.tableHeaders.time')}</TableHeader>
                            {range(1, players[0].speeds.length + 1).map(this.renderSpeedHeader)}
                        </tr>
                    </thead>
                    <tbody>
                        {sortBy(players, 'position').map(this.renderRowPlayer)}
                    </tbody>
                </Table>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/Race/RaceTabCumulative.js